/*
 * @@Copyright (c): Knowdee All rights reserved.
 * @Description: 消息解析器
 * @Author: wangwz@knowdee.com
 * @LastEditors: wangwz@knowdee.com
 * @Date: 2022-05-18 17:26:13
 * @LastEditTime: 2024-01-26 18:30:33
 * @FilePath: /bot-ui/src/common-ts/message.ts
 */
import store from '@/store/index'
import { resolveSignal } from '@/common-ts/resolve'
import { apiGetDialogChat } from '@/apis/dialog/chat'
import $params from '@/common-ts/params'
import { getCurrentTime, getUUID, setPlaceholder } from './utils'
import { scrollIntoViewFn } from '@/common-ts/utils'

export const register = (data: any) => {
  // 清除定时器
  store.commit('dialog/CLEAR_DIALOG_TIMEOUT_TIMER')
  if (!window.location.href.includes('webview')) {
    const placeholder = store.getters['global/pageConfig'].botConfig.input.placeholder
    const content = placeholder.switch ? placeholder.default : ''
    setPlaceholder(content)
  }

  // 更新session
  store.dispatch('session/sessionFn', data.session)
  // 更新消息
  store.dispatch('dialog/messageFn', data.messages)
  // 如果有llmGenerate信号，则不做任何处理
  const llmGenerate = resolveSignal(data.signals, 'llmGenerate')
  if (llmGenerate) {
    const llmMessage = {
      templateType: 'llmGenerate',
      id: getUUID(),
      sendMessageStatus: true,
      dialogInfo: {
        name: store.getters['global/pageConfig'].botConfig.showName || '',
        avatar: store.getters['global/pageConfig'].botConfig.botLogo || '',
        sendTime: getCurrentTime()
      },
      payload: (llmGenerate as any).data
    }
    llmMessage.payload.streamDonedMessage = data.messages
    // 提交用户消息到对话列表
    store.dispatch('dialog/messageFn', llmMessage)

    return false
  }
  // 如果有stream信号，则不做任何处理
  const stream = resolveSignal(data.signals, 'stream')
  if (stream) {
    const llmMessage = {
      templateType: 'stream',
      id: getUUID(),
      sendMessageStatus: true,
      dialogInfo: {
        name: store.getters['global/pageConfig'].botConfig.showName || '',
        avatar: store.getters['global/pageConfig'].botConfig.botLogo || '',
        sendTime: getCurrentTime()
      },
      payload: (stream as any).data
    }
    llmMessage.payload.streamDonedMessage = data.messages
    // 提交用户消息到对话列表
    store.dispatch('dialog/messageFn', llmMessage)

    return false
  }

  // 更新信号
  store.dispatch('signals/signalsFn', data.signals)
  // 解析timeout动态定时器
  const timeout = resolveSignal(data.signals, 'timeOut')
  if (timeout && !(store.getters['signals/agentStatusChangeMF'] === '5' || store.getters['signals/agentStatusChangeMF'] === '4') && !window.location.href.includes('webview')) {
    resolveTimeout(timeout)
  }

  // 将用户请求动作的状态设置为 false 标记着用户请求动作已经完成正在解析新数据
  store.commit('dialog/SET_USER_REQUEST_ACTION_STATUS', true)

  // 如果有survey信号，则对data.message数组填充一个对象，作为betterScroll判断返回模版的长度。
  const survey = resolveSignal(data.signals, 'survey')
  if (survey) {
    data.messages.push({})
    store.dispatch('dialog/botMessageFn', data.messages)
  } else {
    store.dispatch('dialog/botMessageFn', data.messages)
  }
  // setSignals(data)
}

// 注册历史消息进入对话区域
export const registerHistory = (data: any, scrollToStr:string) => {
  store.dispatch('dialog/messageFnHistory', data.messages)
  // 滚动条滚动到指定dom上
  setTimeout(() => {
    scrollIntoViewFn(document.querySelector('.content') as any [0], scrollToStr)
  }, 1000)
}

/**
 *
 * @description: timeout 动态请求
 * @return: {void} 无返回
 *
 */
// 计时器对象定义
// let timeoutTimer:any = null
const resolveTimeout = (data: any) => {
  // clearTimeout(timeoutTimer)
  // 清除定时器
  store.commit('dialog/CLEAR_DIALOG_TIMEOUT_TIMER')
  // 解析出signals响应回来的数据
  const signalsData = data.data
  const signalsType = data.type
  // 组装参数
  const params = $params.getDialogChatParams()
  params.queryType = signalsType
  params.queryMessage = JSON.stringify(signalsData.value)
  // 设置定时器
  store.commit('dialog/SET_DIALOG_TIMEOUT_TIMER', setTimeout(() => {
    if (store.getters['signals/agentStatusChangeMF'] === '5' || store.getters['signals/agentStatusChangeMF'] === '4') {
      // 清除定时器
      store.commit('dialog/CLEAR_DIALOG_TIMEOUT_TIMER')
      return false
    }
    console.log(`计时器${signalsData.time}秒钟倒计时结束，发起请求，参数为：`, JSON.stringify(params))
    apiGetDialogChat(params).then((res) => {
      // 清除定时器
      store.commit('dialog/CLEAR_DIALOG_TIMEOUT_TIMER')
      register(res.data.data)
    })
  }, signalsData.time * 1000))
}

// /**
//    * @description 设置PC Mobile端信号
//    * @param {Object} results 对话接口返回的对象
//    */
// const setSignals = (results:any) => {
//   // 处理signal
//   if (results.signals.length !== 0) {
//     store.commit('signals/CLEAR_SIGNALS_DATA', [])
//     results.signals.map((value:any) => {
//       // callback模板 commit 到 vuex
//       if (value.type === 'selfCreateOderService' || value.type === 'selfCreateOderServiceCommitResult' || value.type === 'selfCreateEBIOrderService') {
//         store.commit('dialog/SET_CALLBACK_STATUS', value)
//       }
//     })
//   }
// }
